<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-data-table
        :mobile-breakpoint="mobilebreakpoint"
        :headers="headers"
        :items="listingData"
        :items-per-page="-1"
        :search="search"
        class="elevation-4 mt-2"
        :loading="tableLoading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.Title="{ item }">
          <a
            v-if="item.Title === 'Fees paid Till Date (G)'"
            @click="ToPaymentDetails(item.Title)"
            >{{ item.Title }}</a
          >
          <a
            v-else-if="item.Title === 'Pending Fees (H=F-G)'"
            @click="ToDuePay(item.Title)"
            >{{ item.Title }}</a
          >
          <span v-else>{{ item.Title }}</span>
        </template>
        <template
          v-for="header in headers.filter((header) =>
            header.hasOwnProperty('money')
          )"
          v-slot:[`item.${header.value}`]="{ header, value }"
        >
          {{ formatNumber(value) }}
        </template>
      </v-data-table>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}

.subtotal {
  background-color: yellow;
}
</style>
<script>
import axios from "axios";
import { get, sync } from "vuex-pathify";
import { formatDate, formatNumber } from "../util/helpers";
import vconfirm from "@/components/v-confirm";

import moment from "moment";
import { showSnackbar } from "../util/globalActions";

export default {
  name: "FeeDetailsView",
  components: { vconfirm },

  data: () => ({
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    listingData: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [
      {
        text: "Description",
        value: "Title",
        width: "300px",
      },
    ],
  }),
  created() {
    //this.headers = [];
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selectedfromdate: sync("app/attendancefromdate"),
    calenderselecteddate: get("app/calenderselecteddate"),
    fromDashboard: sync("app/fromDashboard"),
    selectedtodate: sync("app/attendancetodate"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatNumber,
    formatDate,
    getParameter() {
      const self = this;
      const fromDate = new Date(self.fromDate).toJSON();
      const toDate = new Date(self.toDate).toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };
      return data;
    },
    getDefaultDate() {
      const self = this;
      axios({
        url: self.apiUrl + "api/Common/getAcademicToday",

        method: "GET",
        responseType: "json",
      }).then(function(response) {
        self.fromDate = moment(new Date(response.data.fromDate)).format(
          "YYYY-MM-DD"
        );
        self.toDate = moment(new Date(response.data.toDate)).format(
          "YYYY-MM-DD"
        );

        self.showData();
      });
    },

    showData() {
      const self = this;
      self.headers = [];
      self.headers.push({
        text: "Description",
        value: "Title",
        width: "300px",
      });

      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;
      const data = self.getParameter();

      axios({
        url: self.apiUrl + "api/Fees/FeesDetails",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          res.data.cols.forEach((element) => {
            self.headers.push({
              text: element.Caption,
              value: element.ColName,
              width: "100px",
              align: "right",
              money:"Yes",
            });
          });
          self.listingData = res.data.data;

          self.tableLoading = false;
          self.hiddenPDF = false;
        })
        .catch(function(err) {
          self.hiddenPDF = true;
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    row_classes(item) {
      return item.rowcolor.toLowerCase();
    },
    sumSubField(key, subject) {
      // sum data in give key (property)
      const subjectgroup = this.listingData.filter(
        (item) => item.suB_NAME === subject
      );
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumMnthField(key, mname) {
      // sum data in give key (property)
      const subjectgroup = this.listingData.filter(
        (item) => item.mname === mname
      );
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumTotal(key) {
      // sum data in give key (property)
      const subjectgroup = this.listingData;
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
    closeAll() {
      Object.keys(this.$refs).forEach((k) => {
        console.log(this.$refs[k]);
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    openAll() {
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && !this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    ToPaymentDetails() {
      this.$router.push({ name: "Payment Details" });
    },
    ToDuePay(){
      this.$router.push({ name: "Due Pay" });
    },
  },
};
</script>
